import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function professor(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@professores/REQUEST_PROFESSORES_SUCCESS': {
        draft.data = action.payload.professores;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
